import React, { useEffect, useState } from 'react';
import type { FC } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import type { SpacePermission, SpaceRole } from '../../model/space-roles-types.ts';
import { buildPermissionDescriptionTooltips } from '../update-principal/roles-only/buildPermissionDescriptionTooltips.tsx';

import { ViewRolePermissionsWrapper } from './ViewRolePermissionsWrapper.tsx';
import { RoleListButtons } from './RoleListButtons.tsx';
export interface ViewRolePermissionModalProps {
	systemRoles: SpaceRole[];
	customRoles?: SpaceRole[];
	allPermissions?: SpacePermission[];
	initialActiveRoleId?: string;
	analyticsSource: string;
	onClose: () => void;
	onClickEdit?: (roleId?: string) => void;
}

export const ViewRolePermissionModal: FC<ViewRolePermissionModalProps> = ({
	systemRoles,
	customRoles,
	allPermissions,
	onClose,
	initialActiveRoleId,
	analyticsSource,
	onClickEdit,
}) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const [activeRoleId, setActiveRoleId] = useState<string>(
		initialActiveRoleId || systemRoles[0]?.id || '',
	);

	useEffect(
		() => {
			createAnalyticsEvent({
				type: 'sendScreenEvent',
				data: {
					name: 'viewRolePermissionsModal',
					attributes: {
						source: analyticsSource,
					},
				},
			}).fire();
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[],
	);

	return (
		<ViewRolePermissionsWrapper
			systemRoles={systemRoles}
			customRoles={customRoles}
			allPermissions={allPermissions}
			activeRoleId={activeRoleId}
			setActiveRoleId={setActiveRoleId}
			analyticsSource={analyticsSource}
			onClose={onClose}
			onClickEdit={onClickEdit}
			extraPermissionContent={buildPermissionDescriptionTooltips(allPermissions ?? [])}
		>
			<RoleListButtons
				systemRoles={systemRoles}
				customRoles={customRoles || []}
				activeRoleId={activeRoleId}
				setActiveRoleId={setActiveRoleId}
			/>
		</ViewRolePermissionsWrapper>
	);
};
